var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176,
    height: 176,
    viewBox: "0 0 176 176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 88,
    r: 80,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m133.8 121.1-44-84a2.06 2.06 0 0 0-3.5 0l-44 84a2.09 2.09 0 0 0 1.8 3h88a2.06 2.06 0 0 0 1.7-1 2 2 0 0 0 0-2z",
    fill: "#ffe082"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132 125H44a3.42 3.42 0 0 1-2.6-1.4 3 3 0 0 1-.1-2.9l44-84a3 3 0 0 1 2.7-1.5 3.15 3.15 0 0 1 2.7 1.5l44 84a3 3 0 0 1-.1 2.9 3.42 3.42 0 0 1-2.6 1.4zM88 37.1a1 1 0 0 0-.9.5l-44 84a.91.91 0 0 0 0 1 1.05 1.05 0 0 0 .9.5h88a1.19 1.19 0 0 0 .9-.5.91.91 0 0 0 0-1l-44-84a1 1 0 0 0-.9-.5z",
    fill: "#78909c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88 113a5 5 0 1 1 5-5 5 5 0 0 1-5 5zm0-14a3 3 0 0 1-3-3V70a3 3 0 0 1 6 0v26a3 3 0 0 1-3 3z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88 68a2 2 0 0 1 2 2v26a2 2 0 0 1-4 0V70a2 2 0 0 1 2-2m0 36a4 4 0 1 1-4 4 4 4 0 0 1 4-4m0-38a4 4 0 0 0-4 4v26a4 4 0 0 0 8 0V70a4 4 0 0 0-4-4zm0 36a6 6 0 1 0 6 6 6 6 0 0 0-6-6z",
    fill: "#78909c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.b076d670c877120da6513b4e9a00b0b6.svg";
export { ForwardRef as ReactComponent };